// extracted by mini-css-extract-plugin
export var half = "header-module--half--RCNpR";